function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.058594 2.808594 C 10.253906 2.316406 9.675781 1.527344 9.496094 0.613281 C 9.457031 0.414062 9.433594 0.210938 9.433594 0 L 6.871094 0 L 6.867188 9.644531 C 6.824219 10.726562 5.878906 11.589844 4.71875 11.589844 C 4.355469 11.589844 4.015625 11.507812 3.71875 11.359375 C 3.03125 11.019531 2.5625 10.347656 2.5625 9.570312 C 2.5625 8.453125 3.53125 7.546875 4.71875 7.546875 C 4.9375 7.546875 5.152344 7.582031 5.351562 7.640625 L 5.351562 5.183594 C 5.144531 5.15625 4.933594 5.140625 4.71875 5.140625 C 2.117188 5.140625 0 7.125 0 9.570312 C 0 11.066406 0.796875 12.394531 2.015625 13.195312 C 2.78125 13.699219 3.710938 14 4.71875 14 C 7.320312 14 9.433594 12.011719 9.433594 9.570312 L 9.433594 4.679688 C 10.4375 5.355469 11.671875 5.753906 13 5.753906 L 13 3.347656 C 12.285156 3.347656 11.617188 3.148438 11.058594 2.808594 Z M 11.058594 2.808594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.bc047ac4b4bd9ce16e00eaf1430bd9d7.svg";
export { ForwardRef as ReactComponent };